var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "absolute right-9 top-40 -mt-3 z-30 mb-5 pb-6 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none",
      attrs: {
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1",
      },
    },
    [
      _c("div", [
        _c("div", [
          _c("a", { staticClass: "flex", attrs: { href: "#" } }, [
            _c(
              "div",
              { staticClass: "p-3" },
              [
                _c(
                  "custom-button",
                  {
                    attrs: { isOutlined: true },
                    on: { click: _vm.clearAllFilters },
                  },
                  [_vm._v(" Clear All ")]
                ),
              ],
              1
            ),
            _c("img", {
              staticClass: "mx-auto h-6 w-auto mr-3 mt-5",
              attrs: {
                src: require("@/assets/Close.svg"),
                alt: "close filter",
              },
              on: { click: _vm.closeModal },
            }),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "flex flex-wrap mx-6 px-1 py-3 border-b-1 border-t-1",
          },
          _vm._l(_vm.selectedFilters, function (item, index) {
            return _c("div", { staticClass: "flex flex-col mr-1" }, [
              _c("span", { staticClass: "filter-header" }, [
                _vm._v(_vm._s(item.type)),
              ]),
              _c(
                "span",
                {
                  staticClass:
                    "py-1 px-1 rounded-full font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease chip-button",
                },
                [
                  _vm._v(" " + _vm._s(item.value) + " "),
                  _c(
                    "button",
                    {
                      staticClass:
                        "text-white ml-2 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-0.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800",
                      staticStyle: { "background-color": "#107498" },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.removeFilter(index)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "w-4 h-4",
                          attrs: {
                            "aria-hidden": "true",
                            focusable: "false",
                            "data-prefix": "fas",
                            "data-icon": "times",
                            role: "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 352 512",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              fill: "currentColor",
                              d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z",
                            },
                          }),
                        ]
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v("Icon description"),
                      ]),
                    ]
                  ),
                ]
              ),
            ])
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "grid grid-cols-2 mt-2" },
          [
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Country" } },
              [
                _c("ProfileCountrySelect", {
                  attrs: { multiple: false },
                  on: { input: _vm.selectCountry },
                  model: {
                    value: _vm.filterFields.countries,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "countries", $$v)
                    },
                    expression: "filterFields.countries",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6 -ml-6" },
              [
                _c("RegionInput", {
                  attrs: {
                    countries: _vm.filterFields.countries,
                    multiple: false,
                  },
                  on: { enter: _vm.selectRegion },
                  model: {
                    value: _vm.filterFields.states,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "states", $$v)
                    },
                    expression: "filterFields.states",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "City" } },
              [
                _c("UserCityMultiselect", {
                  attrs: {
                    country: _vm.countriesNames,
                    state: _vm.statesNames,
                  },
                  on: { input: _vm.selectCity },
                  model: {
                    value: _vm.filterFields.cities,
                    callback: function ($$v) {
                      _vm.$set(_vm.filterFields, "cities", $$v)
                    },
                    expression: "filterFields.cities",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6 -ml-6", attrs: { title: "Time Range" } },
              [
                _c("FormDateRangePicker", {
                  attrs: { value: _vm.dateRange },
                  on: { input: _vm.handleDateRangeChange },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Project Criteria" } },
              [
                _c("select-button", {
                  staticClass: "flex",
                  attrs: { options: _vm.projectCriterias },
                  on: { input: _vm.selectProjectCriteria },
                }),
              ],
              1
            ),
            _c("FormGroup", {
              staticClass: "pr-6",
              attrs: { title: "Project Name" },
              on: { enter: _vm.selectProjectName },
              model: {
                value: _vm.projectName,
                callback: function ($$v) {
                  _vm.projectName = $$v
                },
                expression: "projectName",
              },
            }),
            _c(
              "FormGroup",
              { staticClass: "px-6", attrs: { title: "Project Status" } },
              [
                _c("select-button", {
                  staticClass: "flex",
                  attrs: { options: _vm.projectStatuses },
                  on: { input: _vm.selectProjectStatus },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }